module.exports = __webpack_public_path__ + "static/accname-82cb57a135ee576b4b1119ce87924b58.png";